<template>
  <v-container class="flex-wrap align-start fill-height" fluid>
    <!--    carousel-->
    <!--    <v-row class="mb-1" align="center" justify="center">-->
    <!--      <v-col class="pa-0" cols="12" lg="12" sm="12" md="12" xl="8">-->
    <!--        <CarouselTop />-->
    <!--      </v-col>-->
    <!--    </v-row>-->
    <CarouselWrapper />
    <!--    form-->
    <v-row
      :class="$vuetify.breakpoint.lgAndUp ? 'mt-12' : ''"
      justify="center"
      align="start"
    >
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
        xl="3"
        :class="$vuetify.breakpoint.mdAndDown ? 'mb-4' : 'pr-4'"
      >
        <div class="px-3" :class="{ 'px-0': $vuetify.breakpoint.mdAndDown }">
          <v-card-text
            class="pr-0 font-weight-light text-center display-2"
            :class="{ 'display-1': $vuetify.breakpoint.mdAndDown }"
          >
            Как подобрать?
          </v-card-text>
          <p>
            Для оформления заказа Вам необходимо заполнить форму с учетом Ваших
            пожеланий.
          </p>
          <p class="mt-2">
            Наши менеджеры оперативно свяжутся с Вами для уточнения заказа и
            предоставления информации о наличии товара.
          </p>
          <p>
            Получить свой товар Вы можете с помощью самовывоза.
          </p>
          <p>
            Вы также можете оплатить заранее согласованный и подтвержденный
            заказ прямо у нас на сайте, нажав кнопку ниже.
          </p>
          <v-row class="mt-4" justify="center">
            <v-btn color="secondary" dark @click.stop="dialog = true">
              Оплатить
            </v-btn>
            <v-dialog v-model="dialog" max-width="420">
              <v-card>
                <v-card-title />
                <link
                  rel="stylesheet"
                  href="https://yookassa.ru/integration/simplepay/css/yookassa_construct_form.css"
                />
                <form
                  class="mx-1 yoomoney-payment-form"
                  action="https://yookassa.ru/integration/simplepay/payment"
                  method="post"
                  accept-charset="utf-8"
                >
                  <div class="ym-payment-btn-block ym-align-space-between">
                    <div class="ym-input-icon-rub">
                      <input
                        name="sum"
                        placeholder="0.00"
                        class="ym-input ym-sum-input ym-required-input"
                        type="number"
                        step="any"
                      />
                    </div>
                    <button
                      data-text="Заплатить"
                      class="ym-btn-pay ym-result-price"
                    >
                      <span class="ym-text-crop">Заплатить</span>
                      <span class="ym-price-output"></span>
                    </button>
                    <svg
                      class="ym-logo"
                      width="140"
                      height="30"
                      viewBox="0 0 369 63"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-labelledby="logoTitle"
                      role="img"
                    >
                      <path
                        d="M57.355 0C39.6901 0 25.6958 14.1522 25.6958 31.5C25.6958 48.8478 39.9195 63 57.355 63C74.7906 63 89.0143 48.8478 89.0143 31.5C89.2437 14.1522 74.7906 0 57.355 0ZM57.355 43.1413C50.9314 43.1413 45.4255 37.8913 45.4255 31.5C45.4255 25.1087 50.702 19.8587 57.355 19.8587C64.0081 19.8587 69.2846 25.1087 69.2846 31.5C69.0552 37.8913 64.0081 43.1413 57.355 43.1413Z"
                        fill="url(#paint0_linear)"
                      ></path>
                      <path
                        d="M25.6945 9.35889V55.2393H14.4531L0 9.35889H25.6945Z"
                        fill="url(#paint1_linear)"
                      ></path>
                      <path
                        d="M128.423 2.4231L128.423 63"
                        stroke="black"
                      ></path>
                      <path
                        d="M216.393 54H212.701V48.7702H201.307V54H197.615V45.3894H199.25C199.848 43.9807 200.322 42.4312 200.674 40.7408C201.026 39.0151 201.289 37.2543 201.465 35.4582C201.676 33.6269 201.799 31.778 201.835 29.9115C201.905 28.0098 201.94 26.1785 201.94 24.4177V22.1462H214.283V45.3894H216.393V54ZM234.275 46.9742C233.431 47.6433 232.464 48.1715 231.374 48.5589C230.284 48.9463 229.07 49.14 227.734 49.14C224.991 49.14 222.829 48.0835 221.246 45.9705C219.664 43.8223 218.872 40.6879 218.872 36.5675C218.872 34.4193 219.013 32.4472 219.294 30.6511C219.611 28.855 220.086 27.3055 220.719 26.0024C221.387 24.6642 222.231 23.6253 223.251 22.8857C224.27 22.1462 225.484 21.7764 226.89 21.7764C227.98 21.7764 228.983 22.0053 229.897 22.4631C230.811 22.8857 231.585 23.5901 232.218 24.5762C232.851 25.5622 233.343 26.8477 233.695 28.4324C234.046 29.982 234.222 31.8837 234.222 34.1376V36.4091H223.145C223.145 39.4377 223.549 41.7268 224.358 43.2764C225.202 44.8259 226.451 45.6007 228.103 45.6007C229.264 45.6007 230.284 45.407 231.163 45.0196C232.077 44.597 232.798 44.192 233.326 43.8046L234.275 46.9742ZM195.241 22.1462V48.7702H191.179V36.8317H185.06V48.7702H180.946V22.1462H185.06V33.4508H191.179V22.1462H195.241ZM242.557 35.511V48.7702H238.442V22.1462H242.557V34.4545L248.939 22.1462H253.106L246.513 34.6658L254.056 48.7702H249.572L242.557 35.511ZM263.709 49.14C260.86 49.14 258.627 48.0131 257.01 45.7592C255.392 43.4701 254.583 40.0364 254.583 35.4582C254.583 33.3804 254.777 31.4963 255.164 29.8059C255.586 28.1155 256.183 26.6892 256.957 25.527C257.766 24.3296 258.75 23.414 259.911 22.7801C261.107 22.111 262.478 21.7764 264.025 21.7764C265.221 21.7764 266.188 21.9173 266.927 22.199C267.665 22.4455 268.333 22.7625 268.931 23.1499L268.351 27.059C267.788 26.5659 267.12 26.1433 266.346 25.7911C265.608 25.4038 264.817 25.2101 263.973 25.2101C262.496 25.2101 261.282 26.0377 260.333 27.6929C259.383 29.3481 258.909 31.8661 258.909 35.2469C258.909 38.5925 259.296 41.181 260.069 43.0123C260.878 44.8083 262.126 45.7064 263.814 45.7064C264.834 45.7064 265.713 45.5479 266.452 45.2309C267.19 44.8788 267.806 44.4914 268.298 44.0688L269.247 47.1326C268.544 47.7313 267.753 48.2244 266.874 48.6118C265.995 48.9639 264.94 49.14 263.709 49.14ZM210.222 25.4742H205.632V25.9496C205.632 27.3583 205.597 28.9078 205.527 30.5983C205.492 32.2535 205.386 33.9439 205.21 35.6695C205.035 37.3951 204.788 39.1032 204.472 40.7936C204.155 42.4488 203.716 43.9807 203.153 45.3894H210.222V25.4742ZM226.89 25.1572C225.624 25.1572 224.728 25.8792 224.2 27.3231C223.673 28.7318 223.338 30.6335 223.198 33.0282H230.002C230.002 31.9013 229.95 30.8624 229.844 29.9115C229.739 28.9255 229.563 28.0802 229.317 27.3759C229.106 26.6716 228.789 26.1257 228.367 25.7383C227.98 25.3509 227.488 25.1572 226.89 25.1572Z"
                        fill="black"
                        fill-opacity="0.9"
                      ></path>
                      <path
                        d="M284.557 28.855V48.7702H281.919V11H284.557V28.6437L295.581 11H298.113L287.247 28.4324L299.062 48.7702H296.109L284.557 28.855Z"
                        fill="black"
                        fill-opacity="0.9"
                      ></path>
                      <path
                        d="M307.23 47.2911C308.461 47.2911 309.498 46.7805 310.342 45.7592C311.221 44.7379 311.907 43.5053 312.399 42.0614V34.7187H309.551C307.335 34.7187 305.7 35.2469 304.645 36.3034C303.59 37.3599 303.063 39.0503 303.063 41.3747C303.063 43.2764 303.432 44.7379 304.17 45.7592C304.944 46.7805 305.964 47.2911 307.23 47.2911ZM313.138 48.7702C313.032 48.4181 312.909 47.9779 312.768 47.4496C312.663 46.8861 312.575 46.129 312.505 45.1781C311.872 46.4459 311.081 47.4496 310.131 48.1892C309.182 48.9287 308.039 49.2985 306.702 49.2985C304.909 49.2985 303.45 48.6294 302.324 47.2911C301.199 45.9177 300.636 44.0159 300.636 41.586C300.636 38.7334 301.392 36.5852 302.904 35.1413C304.417 33.6621 306.614 32.9226 309.498 32.9226H312.399V29.5946C312.399 27.552 312.03 26.0729 311.292 25.1572C310.553 24.2416 309.445 23.7838 307.968 23.7838C306.843 23.7838 305.788 24.0479 304.803 24.5762C303.819 25.0692 303.01 25.7735 302.377 26.6892L301.691 24.312C302.219 23.6077 303.01 22.9914 304.065 22.4631C305.155 21.8997 306.456 21.6179 307.968 21.6179C310.184 21.6179 311.872 22.2518 313.032 23.5196C314.228 24.7522 314.826 26.6892 314.826 29.3305V43.8575C314.826 44.7731 314.878 45.7064 314.984 46.6572C315.089 47.5729 315.23 48.2772 315.406 48.7702H313.138Z"
                        fill="black"
                        fill-opacity="0.9"
                      ></path>
                      <path
                        d="M327.938 47.1326C328.782 47.1326 329.521 46.9918 330.154 46.71C330.822 46.4283 331.385 46.0937 331.842 45.7064C332.369 45.319 332.826 44.8435 333.213 44.2801L334.004 46.3403C333.618 46.9037 333.125 47.3968 332.527 47.8194C332.035 48.2068 331.385 48.5413 330.576 48.8231C329.802 49.14 328.905 49.2985 327.886 49.2985C325.213 49.2985 323.138 48.1011 321.661 45.7064C320.219 43.2764 319.498 39.8779 319.498 35.511C319.498 31.1089 320.219 27.6929 321.661 25.2629C323.103 22.8329 325.195 21.6179 327.938 21.6179C329.31 21.6179 330.47 21.8644 331.42 22.3575C332.369 22.8153 333.143 23.3964 333.741 24.1007L333.055 26.742C332.457 25.932 331.736 25.2277 330.892 24.629C330.048 24.0303 329.064 23.7309 327.938 23.7309C325.899 23.7309 324.387 24.7522 323.402 26.7948C322.452 28.8374 321.978 31.7428 321.978 35.511C321.978 39.1736 322.452 42.0262 323.402 44.0688C324.351 46.1114 325.864 47.1326 327.938 47.1326Z"
                        fill="black"
                        fill-opacity="0.9"
                      ></path>
                      <path
                        d="M344.937 47.1326C345.781 47.1326 346.52 46.9918 347.153 46.71C347.821 46.4283 348.384 46.0937 348.841 45.7064C349.368 45.319 349.825 44.8435 350.212 44.2801L351.004 46.3403C350.617 46.9037 350.124 47.3968 349.527 47.8194C349.034 48.2068 348.384 48.5413 347.575 48.8231C346.801 49.14 345.904 49.2985 344.885 49.2985C342.212 49.2985 340.137 48.1011 338.66 45.7064C337.218 43.2764 336.498 39.8779 336.498 35.511C336.498 31.1089 337.218 27.6929 338.66 25.2629C340.102 22.8329 342.194 21.6179 344.937 21.6179C346.309 21.6179 347.469 21.8644 348.419 22.3575C349.368 22.8153 350.142 23.3964 350.74 24.1007L350.054 26.742C349.456 25.932 348.735 25.2277 347.891 24.629C347.047 24.0303 346.063 23.7309 344.937 23.7309C342.898 23.7309 341.386 24.7522 340.401 26.7948C339.452 28.8374 338.977 31.7428 338.977 35.511C338.977 39.1736 339.452 42.0262 340.401 44.0688C341.35 46.1114 342.863 47.1326 344.937 47.1326Z"
                        fill="black"
                        fill-opacity="0.9"
                      ></path>
                      <path
                        d="M360.236 47.2911C361.467 47.2911 362.504 46.7805 363.348 45.7592C364.228 44.7379 364.913 43.5053 365.406 42.0614V34.7187H362.557C360.342 34.7187 358.706 35.2469 357.652 36.3034C356.597 37.3599 356.069 39.0503 356.069 41.3747C356.069 43.2764 356.438 44.7379 357.177 45.7592C357.95 46.7805 358.97 47.2911 360.236 47.2911ZM366.144 48.7702C366.039 48.4181 365.915 47.9779 365.775 47.4496C365.669 46.8861 365.581 46.129 365.511 45.1781C364.878 46.4459 364.087 47.4496 363.137 48.1892C362.188 48.9287 361.045 49.2985 359.709 49.2985C357.915 49.2985 356.456 48.6294 355.331 47.2911C354.205 45.9177 353.643 44.0159 353.643 41.586C353.643 38.7334 354.399 36.5852 355.911 35.1413C357.423 33.6621 359.621 32.9226 362.504 32.9226H365.406V29.5946C365.406 27.552 365.036 26.0729 364.298 25.1572C363.559 24.2416 362.452 23.7838 360.975 23.7838C359.849 23.7838 358.794 24.0479 357.81 24.5762C356.825 25.0692 356.016 25.7735 355.383 26.6892L354.698 24.312C355.225 23.6077 356.016 22.9914 357.071 22.4631C358.161 21.8997 359.463 21.6179 360.975 21.6179C363.19 21.6179 364.878 22.2518 366.039 23.5196C367.234 24.7522 367.832 26.6892 367.832 29.3305V43.8575C367.832 44.7731 367.885 45.7064 367.99 46.6572C368.096 47.5729 368.236 48.2772 368.412 48.7702H366.144Z"
                        fill="black"
                        fill-opacity="0.9"
                      ></path>
                      <path
                        d="M168.24 34.2961L161.805 48.7702H157.11L164.178 33.2924C162.526 32.4472 161.189 31.2146 160.17 29.5946C159.15 27.9394 158.64 25.7031 158.64 22.8857C158.64 20.9136 158.921 19.188 159.484 17.7088C160.082 16.1945 160.873 14.9443 161.857 13.9582C162.877 12.9722 164.055 12.2326 165.392 11.7396C166.728 11.2465 168.135 11 169.612 11H175.678V48.7702H171.616V34.2961H168.24ZM171.616 14.4337H169.453C168.645 14.4337 167.853 14.5921 167.08 14.9091C166.306 15.1908 165.62 15.6663 165.022 16.3354C164.425 16.9693 163.932 17.8321 163.545 18.9238C163.194 19.9803 163.018 21.301 163.018 22.8857C163.018 24.4001 163.176 25.6679 163.493 26.6892C163.844 27.7105 164.302 28.5381 164.864 29.172C165.462 29.8059 166.148 30.2637 166.921 30.5454C167.73 30.792 168.574 30.9152 169.453 30.9152H171.616V14.4337Z"
                        fill="#EE2E24"
                      ></path>
                      <defs>
                        <linearGradient
                          id="paint0_linear"
                          x1="57.3564"
                          y1="0"
                          x2="57.3564"
                          y2="63"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#0160D1"></stop>
                          <stop offset="1" stop-color="#00479C"></stop>
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear"
                          x1="12.8472"
                          y1="9.35889"
                          x2="12.8472"
                          y2="55.2393"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#0160D1"></stop>
                          <stop offset="1" stop-color="#00479C"></stop>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <input name="shopId" type="hidden" value="760566" />
                </form>
                <br /><br />
              </v-card>
            </v-dialog>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="11" xl="5">
        <v-card>
          <v-tabs
            class="px-0"
            v-model="tab"
            background-color="secondary"
            centered
            icons-and-text
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-1">
              Подбор <br class="d-lg-none d-xl-none" />шин
              <!--              <v-icon>mdi-phone</v-icon>-->
            </v-tab>

            <v-tab href="#tab-2">
              Подбор <br class="d-lg-none d-xl-none" />дисков
              <!--              <v-icon>mdi-heart</v-icon>-->
            </v-tab>

            <v-tab href="#tab-3">
              Подбор <br class="d-lg-none d-xl-none" />шин и дисков
              <!--              <v-icon>mdi-account-box</v-icon>-->
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
              <v-col>
                <FormTires />
              </v-col>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <v-col>
                <FormDisks />
              </v-col>
            </v-tab-item>
            <v-tab-item value="tab-3">
              <v-col>
                <FormTiresNDisks />
              </v-col>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
    <!--    carouselBrands-->
    <v-row class="mb-1" align="center" justify="center">
      <v-col class="pa-0" cols="12" lg="12" sm="12" md="12" xl="8">
        <BrandSlide />
      </v-col>
    </v-row>
    <!--    textBlocks1-->
    <v-row align="center" justify="center">
      <v-col cols="12" xl="10">
        <v-row
          :class="{ 'px-8 subtitle-2': $vuetify.breakpoint.lgAndDown }"
          align="start"
          justify="center"
        >
          <v-col
            class="pr-4"
            cols="12"
            sm="12"
            md="6"
            lg="6"
            xl="5"
            :class="{ 'pr-0 mb-6 ': $vuetify.breakpoint.mdAndDown }"
          >
            <div
              class="px-3"
              :class="{ 'px-0': $vuetify.breakpoint.mdAndDown }"
            >
              <v-card-text
                class="mb-12 pa-0 pb-3 font-weight-light text-center display-2"
                :class="{ 'mb-1 display-1': $vuetify.breakpoint.mdAndDown }"
              >
                Наши преимущества:
              </v-card-text>
              <v-card-text
                :class="{ 'subtitle-2': $vuetify.breakpoint.mdAndDown }"
                class="pa-0 text-justify title font-weight-light"
              >
                Мы предложим Вам максимально выгодную цену при покупке шин или
                дисков в нашей компании!
                <div class="mt-4">
                  <ul>
                    <li>
                      Работаем напрямую с оптовыми складами автомобильных шин и
                      дисков и стараемся предложить нашим клиентам самую
                      выгодную цену на рынке.
                    </li>
                    <li>
                      Являемся участником оборота маркированных шин Честный знак
                      (постановление Правительства РФ от 31 декабря 2019 г. №
                      1958)
                    </li>
                    <li>
                      Наш профессиональный шиномонтаж—«Колёсный сервис» работает
                      на рынке услуг целых 16 лет!
                    </li>
                  </ul>
                </div>
              </v-card-text>
            </div>
          </v-col>
          <v-col
            class="pl-4"
            cols="12"
            sm="12"
            md="6"
            lg="6"
            xl="5"
            :class="{ 'pl-0 mb-6 ': $vuetify.breakpoint.mdAndDown }"
          >
            <div
              class="px-3"
              :class="{ 'px-0': $vuetify.breakpoint.mdAndDown }"
            >
              <v-card-text
                class="mb-12 pa-0 pb-3 font-weight-light text-center display-2"
                :class="{ 'mb-1 display-1': $vuetify.breakpoint.mdAndDown }"
              >
                Выгодно!
              </v-card-text>
              <v-card-text
                :class="{ 'subtitle-2': $vuetify.breakpoint.mdAndDown }"
                class="pa-0 text-justify title font-weight-light"
              >
                Мы предложим Вам максимально выгодную цену при покупке шин или
                дисков в нашей компании!
                <p class="mt-2">
                  У нас действует акция
                  <span
                    @click="onClickInst"
                    class="primary--text pointer font-weight-regular"
                    >"Подпишись на инстаграм—получи скидку!"</span
                  >
                </p>
                <p class="mt-4">
                  На сегодняшний день на рынке шин и дисков представлено
                  множество различных брендов отличающихся не только ценой , но
                  и разными преимуществами, что делает выбор затруднительным
                  даже опытному автолюбителю, наши консультанты помогут сделать
                  оптимальный выбор опираясь на Ваши предпочтения в соотношение
                  с качеством.
                </p>
              </v-card-text>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!--    headingBlock-->
    <!--    adBlocks-->
    <DiscountsWrapper />

    <!--        textBlocks2-->
    <v-row
      class="mt-16"
      :class="{ 'px-8 subtitle-2': $vuetify.breakpoint.lgAndDown }"
      align="start"
      justify="center"
    >
      <v-col
        class="pr-4"
        cols="12"
        sm="12"
        md="6"
        lg="6"
        xl="4"
        :class="{ 'pr-0 mb-6 ': $vuetify.breakpoint.mdAndDown }"
      >
        <div class="px-3" :class="{ 'px-0': $vuetify.breakpoint.mdAndDown }">
          <v-card-text
            class="pr-0 mb-12 font-weight-light text-center display-2"
            :class="{ 'display-1': $vuetify.breakpoint.mdAndDown }"
          >
            Как подобрать?
          </v-card-text>
          <v-card-text
            :class="{ 'subtitle-2': $vuetify.breakpoint.mdAndDown }"
            class="pa-0 text-justify title font-weight-light"
          >
            Для оформления заказа Вам необходимо заполнить форму ниже с учетом
            Ваших пожеланий.
            <p>
              Наши менеджеры оперативно свяжутся с Вами для уточнения заказа и
              предоставления информации о наличии товара.
            </p>
            <p>
              В настоящее время у нас действует временная акция
              <span
                @click="onClickInst"
                class="primary--text pointer font-weight-regular"
                >"Подпишись на инстаграм—получи скидку!"</span
              >
            </p>
            <p>
              В данный момент доставка нашей компанией не осуществляется,
              действует самовывоз. Мы работаем над решением этой проблемы!
            </p>
          </v-card-text>
        </div>
      </v-col>
      <v-col
        class="pl-4"
        cols="12"
        sm="12"
        md="6"
        lg="6"
        xl="4"
        :class="{ 'pl-0 mb-6 ': $vuetify.breakpoint.mdAndDown }"
      >
        <div class="px-3" :class="{ 'px-0': $vuetify.breakpoint.mdAndDown }">
          <v-card-text
            class="mb-12 pr-0 font-weight-light text-center display-2"
            :class="{ 'mb-6 display-1': $vuetify.breakpoint.mdAndDown }"
          >
            Нашли дешевле?
          </v-card-text>
          <v-card-text
            :class="{ 'subtitle-2': $vuetify.breakpoint.mdAndDown }"
            class="pa-0 text-justify title font-weight-light"
          >
            Пришлите ссылку на интернет магазин, и мы постараемся снизить цену.
            Мы предложим Вам максимально выгодную цену при покупке шин или
            дисков в нашей компании!
            <div class="mt-4">
              <ul>
                <span class="font-weight-regular">Условие:</span>
                <li>Товар должен быть в наличии.</li>
                <li>Товар не должен быть уценённым (шины старше 3х лет).</li>
                <li>Бренд и модель товара должна быть идентичными.</li>
                <li>
                  При сравнении учитываются цены только в магазинах Москвы и
                  Московской области.
                </li>
              </ul>
            </div>
          </v-card-text>
        </div>
      </v-col>
    </v-row>
    <!--    сontacts-->
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="12" lg="12" xl="8" style="min-height: 500px">
        <v-card-text
          class="mb-8 pa-0 pb-3 font-weight-light text-center display-2"
          :class="{ 'display-1': $vuetify.breakpoint.mdAndDown }"
        >
          Где нас найти?
        </v-card-text>
        <GoogleMaps
          src-map="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d559.4210068270022!2d38.425238748683455!3d55.885495437982584!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x414ad83ec77ab789%3A0x11644c02ebe623c7!2z0JrQvtC70LXRgdC90YvQuSDRgdC10YDQstC40YEgKNGI0LjQvdC-0LzQvtC90YLQsNC2KQ!5e0!3m2!1sru!2sru!4v1604163067506!5m2!1sru!2sru"
        />
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-card-text
        class="mb-6 mt-6 pr-0 font-weight-light text-center display-2"
        :class="{ 'display-1': $vuetify.breakpoint.mdAndDown }"
      >
        Контакты
      </v-card-text>
      <v-col
        class="pl-4"
        cols="12"
        sm="12"
        md="6"
        lg="6"
        xl="4"
        :class="{ 'pl-0 mb-6 ': $vuetify.breakpoint.mdAndDown }"
      >
        <div class="px-3" :class="{ 'px-0': $vuetify.breakpoint.mdAndDown }">
          <v-card-text
            :class="{ 'px-7 subtitle-2': $vuetify.breakpoint.mdAndDown }"
            class="pa-0 text-justify title font-weight-light"
          >
            Вы можете связаться с нами с помощью социальных сетей, еmail или
            позвонив по номеру телефона.
            <div class="mt-4">
              <p @click="onClickEmail" class="primary--text pointer">
                zakaz-5tu.ru@yandex.ru
              </p>
              <p @click="onClickTel" class="mb-0 primary--text pointer">
                +7 (999) 555-52-28
              </p>
              <p @click="onClickTel2" class="primary--text pointer">
                +7 (963) 770-37-63
              </p>
              <p class="mb-0">ИП Очканов Олег Александрович</p>
              <p>ОГРНИП: 314503101000010</p>
              <p>Режим работы: 9:00 - 21:00 без выходных</p>
            </div>
          </v-card-text>
        </div>
      </v-col>
      <v-col
        align="center"
        class="pr-2 pt-0"
        xs="11"
        sm="12"
        md="6"
        lg="6"
        xl="4"
      >
        <v-img contain src="/img/ks.jpg"> </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import GoogleMaps from "@/components/GoogleMaps";
import FormTires from "@/components/FormTires";
import FormDisks from "@/components/FormDisks";
import FormTiresNDisks from "@/components/FormTiresNDisks";
// import CarouselTop from "@/components/CarouselTop";
import BrandSlide from "@/components/BrandSlide";
import DiscountsWrapper from "@/components/storyblok/DiscountsWrapper";
import CarouselWrapper from "@/components/storyblok/CarouselWrapper";
export default {
  // created() {
  //   console.log('pre')
  //   if (this.$route.path === '/.well-known') {
  //     // window.open();
  //     console.log('apple pay')
  //     // var a = document.createElement("a");
  //     // document.body.appendChild(a);
  //     // a.style = "display: none";
  //     // var url = 'http://localhost:8080/apple-developer-merchantid-domain-association'
  //     // a.href = url;
  //     // a.target = '_black';
  //     // a.download = 'apple-developer-merchantid-domain-association';
  //     // a.click();
  //     // window.URL.revokeObjectURL(url);
  //     window.open('http://localhost:8080/apple-developer-merchantid-domain-association')
  //   }
  // },
  methods: {
    onClickInst() {
      window.open("https://www.instagram.com/5tu.ru/", "_blank");
    },
    onClickTel() {
      window.open("tel:+79995555228", "_blank");
    },
    onClickTel2() {
      window.open("tel:+79637703763", "_blank");
    },
    onClickEmail() {
      window.open("mailto:shackalowa.dasha@yandex.ru", "_blank");
    }
  },
  name: "Home",
  components: {
    CarouselWrapper,
    DiscountsWrapper,
    BrandSlide,
    GoogleMaps,
    FormTires,
    FormDisks,
    FormTiresNDisks
  },
  data() {
    return {
      src:
        "https://yookassa.ru/integration/simplepay/js/yookassa_construct_form.js",
      dialog: false,
      model: null,
      tab: null,
      mockText:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore " +
        "magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea " +
        "commodo consequat."
    };
  }
};
</script>
<style>
.pointer {
  cursor: pointer;
}
</style>
